import type { PartialMessage } from '@protobuf-ts/runtime';

import type { TrackPropertiesDTO, TrackPropertiesType, TrackResultDTO } from '@nora-monorepo/nora-api-client';
import { PositionResponse } from '@nora-monorepo/track-api-web-client';

export class TrackingUtilities {
  static positionResponseToTrackDTO(position: PositionResponse): TrackResultDTO {
    return {
      id: position.positionId,
      producerId: position.producerId,
      userId: position.producerId, // for backward compatibility
      latitude: position.latitude,
      longitude: position.longitude,
      locationAccuracy: position.locationAccuracy,
      altitude: position.altitude,
      altitudeAccuracy: position.altitudeAccuracy,
      speed: position.speed,
      heading: position.heading,
      serverTimestamp: new Date(position.serverTimestamp),
      clientTimestamp: new Date(position.clientTimestamp),
      properties: position.properties,
      createdAt: new Date(position.serverTimestamp),
      updatedAt: new Date(position.serverTimestamp),
      deletedAt: null,
    };
  }

  static trackDTOToPositionResponse(track: TrackResultDTO): PositionResponse {
    return PositionResponse.create({
      positionId: track.id,
      producerId: track.producerId ?? track.userId,
      latitude: track.latitude,
      longitude: track.longitude,
      locationAccuracy: track.locationAccuracy ?? 0,
      altitude: track.altitude ?? undefined,
      altitudeAccuracy: track.altitudeAccuracy ?? undefined,
      speed: track.speed ?? undefined,
      heading: track.heading ?? undefined,
      serverTimestamp: TrackingUtilities.normalizeDate(track.serverTimestamp),
      clientTimestamp: TrackingUtilities.normalizeDate(track.clientTimestamp),
      // This is adequate at the moment, as the 'deviceId' currently in TrackPropertiesDTO corresponds to the string: string signature. BUT if we later change the TrackPropertiesDTO to also contain a [string]: number field, we are breaking this contract.
      properties: (track.properties) as PartialMessage<{ [key: string]: string }> ?? undefined,
    });
  }

  static normalizeDate(date: Date | string | null | undefined): string | undefined {
    if (!date) {
      return undefined;
    }
    if (date instanceof Date) {
      return date.toISOString();
    }

    return new Date(date).toISOString();
  }

  // TODO use enum when enum issue is fixed
  static getTrackType(position: PositionResponse): TrackPropertiesType | undefined {
    const properties: TrackPropertiesDTO | undefined = position.properties;

    return properties?.type;
  }

  static isTrackerPosition(position: PositionResponse): boolean {
    const trackerType = this.getTrackType(position);

    return trackerType === 'tracker';
  }

  static isUserPosition(position: PositionResponse): boolean {
    const userType = this.getTrackType(position);

    return userType === 'user';
  }
}
